import React, { createContext, useState } from 'react';
import { v4 as uuidv } from 'uuid';
import CustomToast from "./CustomToast.tsx";

// 定义 Toast 项的接口
interface ToastItem {
    id: string;
    type: 'success' | 'error' | 'info' | 'warning';
    message: string;
}

// 创建 ToastContext
export const ToastContext = createContext<{
    toasts: ToastItem[];
    addToast: (toast: Omit<ToastItem, 'id'>) => void;
    removeToast: (id: string) => void;
}>({
    toasts: [],
    addToast: () => {},
    removeToast: () => {},
});

interface  ToastProviderProps {
  children: React.ReactNode;
}


const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
    const [toasts, setToasts] = useState<ToastItem[]>([]);

    // 添加 Toast
    const addToast = (toast: Omit<ToastItem, 'id'>) => {
        if(toasts.length > 0){
            return;
        }
        const id = uuidv();
        const newToast = { ...toast, id };
        setToasts((prevToasts) => [...prevToasts, newToast]);
    };

    // 移除 Toast
    const removeToast = (id: string) => {
        setToasts((prevToasts) => prevToasts.filter((t) => t.id !== id));
    };

    return (
        <ToastContext.Provider value={{ toasts, addToast, removeToast }}>
            {children}
            {/* 在这里显示 Toasts */}
            {toasts.map((toast) => (
                <CustomToast key={toast.id} {...toast} />
            ))}
        </ToastContext.Provider>
    );
};

export default ToastProvider;